import { render, staticRenderFns } from "./FeaturedItem.vue?vue&type=template&id=1ef95804&scoped=true"
import script from "./FeaturedItem.vue?vue&type=script&lang=ts"
export * from "./FeaturedItem.vue?vue&type=script&lang=ts"
import style0 from "./FeaturedItem.vue?vue&type=style&index=0&id=1ef95804&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef95804",
  null
  
)

export default component.exports